<template>
    <div class="bottom-list-wrap" >
        <div v-if="single_data">
            <div class="main-title">
                <h1 v-html="single_data.brand_text1"></h1>
                <h1 v-html="single_data.brand_text2"></h1>
                
                    <div class="duration">
                        <span>活動期間</span>
                        <span>{{single_data.duration}}</span>
                    </div>
                </div>
                <div class="product-list">
                    <ul>
                        <li class="product-title">
                            <span class="p-name">品名</span>
                            <span class="p-code">條碼</span>
                        </li>
                    </ul>
                    <div class="custom-scroller-wrap">
                        <ul class="custom-scroller">
                            <li class="product" v-for="data in single_data.products">
                                <span class="p-name">{{data.p_name}}</span>
                                <span class="p-code">{{data.p_code}}</span>
                            </li>
                        </ul>
                    </div>
                    <!-- <ul class="test"  style="height: 40vh;" v-else>
                        holder

                    </ul> -->
                </div>
            </div>
        </div>
</template>
<script>
// window.$ = window.jQuery = require('jquery');
// import '../scroller';

var $ = require('jquery');
// require("jquery-mousewheel")($);
import 'jquery-mousewheel'
import 'malihu-custom-scrollbar-plugin'
// require('malihu-custom-scrollbar-plugin')($);
export default {
    data(){
        return {
            show: true,
            //single_data: ""
        }
    },
    props: ['single_data'],
    methods: {
        ct_scroll(){
            $(".custom-scroller").mCustomScrollbar({
                theme: "rounded-dots",
                mouseWheelPixels: 80,
                scrollInertia: 0
            });

        }
    },
    watch: {
        '$route' (to, from) {
            $(".custom-scroller").css("opacity", "0");
            // $(".custom-scroller")
            setTimeout(()=>{
                $(".custom-scroller").mCustomScrollbar("destroy");
            },100)
            
            setTimeout(()=>{
                this.ct_scroll()
                $(".custom-scroller").css("opacity", "1");
            },150)
            

        },
        windowWidth(new_w, old_w) {
        //this.slick_list_click();
        }
    },
    created(){
        setTimeout(()=>{
            $(".custom-scroller").css("opacity", "1"); 
            this.ct_scroll();
        },400);
    },
    mounted(){
        
    }
}



</script>
<style lang="sass">
.custom-scroller-wrap
    height: 40vh
.custom-scroller
    height: 40vh
.custom-scroller
    transition: .1s
</style>



// WEBPACK FOOTER //
// src/FlowerList/list.vue